<owl-carousel-o [options]="HomeSliderConfig" class="home-slider " [ngClass]="class">
    <ng-container *ngFor="let slider of sliders">
        <ng-template carouselSlide>
            <a *ngIf="slider.url_type=='service' && slider.type=='innerLink'"
                [routerLink]="['/shop/category',slider.url,slider.title?.split(' ').join('-')]"  aria-label="Go to category">
                <div class="home" [ngClass]="textClass">
                    <img [src]="slider.image" alt="slider_image">
                </div>
            </a>

            <a *ngIf="slider.url_type=='product' && slider.type=='innerLink'"
                [routerLink]="['/shop/product/',slider.url.split(' ').join('-')]"  aria-label="Go to product">
                <div class="home" [ngClass]="textClass">
                    <img [src]="slider.image" alt="slider_image">
                </div>
            </a>

            <a *ngIf="slider.url_type=='trademark' && slider.type=='innerLink'"
                [routerLink]="['/shop/trademarkes/',slider.url,slider.title?.split(' ').join('-')]"  aria-label="Go to trademark">
                <div class="home" [ngClass]="textClass">
                    <img [src]="slider.image" alt="slider_image">
                </div>
            </a>
            <a *ngIf="slider.type=='outerLink'" [href]="[slider.url?.split(' ').join('-')]"  aria-label="Go to outerLink">
                <div class="home" [ngClass]="textClass">
                    <img [src]="slider.image" alt="slider_image">
                </div>
            </a>
        </ng-template>
    </ng-container>
</owl-carousel-o>